import { render, staticRenderFns } from "./_bestowItem.vue?vue&type=template&id=955285be&"
import script from "./_bestowItem.vue?vue&type=script&lang=js&"
export * from "./_bestowItem.vue?vue&type=script&lang=js&"
import style0 from "./_bestowItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports